export default __webpack_public_path__ + "media/polygon-down.287da4a8.svg";